import { Box } from '@mui/material'
import styles from './index.module.scss'
import { WorkflowAppFallbackIcon } from './WorkflowAppFallbackIcon.jsx'

export function WorkflowAppLogo({ iconUrl, pillKind, displayName, variant = 'default' }) {
  const pillClass =
    variant === 'integration' ? `${styles.logoPill} ${styles.logoPillIntegration}` : styles.logoPill

  return (
    <Box className={pillClass} role="img" aria-label={displayName} title={displayName}>
      <span className={styles.logoCircle}>
        {iconUrl ? (
          <img src={iconUrl} alt="" className={styles.logoImg} loading="lazy" decoding="async" />
        ) : (
          <WorkflowAppFallbackIcon pillKind={pillKind} />
        )}
      </span>
    </Box>
  )
}
